module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.583c8d8f.xml";